var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoundOnIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1749_28086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 5.41343C18 3.6321 15.8453 2.7401 14.5867 4.0001L8.58668 10.0001H6.01068C4.48934 10.0001 2.92001 10.8854 2.46401 12.5401C2.15465 13.6674 1.99858 14.8312 2.00001 16.0001C2.00001 17.1974 2.16134 18.3574 2.46668 19.4601C2.92134 21.1134 4.49068 22.0001 6.01201 22.0001H8.58534L14.5853 28.0001C15.8453 29.2601 18 28.3681 18 26.5868V5.41343ZM24.7787 6.8081C24.9662 6.62083 25.2203 6.51565 25.4853 6.51565C25.7503 6.51565 26.0045 6.62083 26.192 6.8081C31.2693 11.8841 31.2693 20.1148 26.192 25.1921C26.1005 25.2903 25.9901 25.3692 25.8674 25.4238C25.7447 25.4785 25.6123 25.5079 25.478 25.5102C25.3438 25.5126 25.2104 25.4879 25.0859 25.4376C24.9614 25.3873 24.8482 25.3124 24.7533 25.2175C24.6583 25.1225 24.5835 25.0094 24.5332 24.8849C24.4829 24.7604 24.4582 24.627 24.4606 24.4927C24.4629 24.3585 24.4923 24.226 24.547 24.1034C24.6016 23.9807 24.6804 23.8703 24.7787 23.7788C25.8003 22.7573 26.6106 21.5446 27.1635 20.2099C27.7164 18.8753 28.001 17.4448 28.001 16.0001C28.001 14.5554 27.7164 13.1249 27.1635 11.7903C26.6106 10.4556 25.8003 9.2429 24.7787 8.22143C24.5914 8.03393 24.4862 7.77977 24.4862 7.51477C24.4862 7.24976 24.5914 6.9956 24.7787 6.8081Z",
    fill: "#FEFEFE"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1749_28086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2442 10.3427C21.3371 10.2498 21.4474 10.176 21.5687 10.1257C21.6901 10.0754 21.8202 10.0496 21.9516 10.0496C22.083 10.0496 22.213 10.0754 22.3344 10.1257C22.4558 10.176 22.566 10.2498 22.6589 10.3427C23.4019 11.0856 23.9913 11.9675 24.3934 12.9382C24.7956 13.9089 25.0025 14.9493 25.0025 16C25.0025 17.0507 24.7956 18.0911 24.3934 19.0618C23.9913 20.0325 23.4019 20.9145 22.6589 21.6573C22.4702 21.8394 22.2176 21.9401 21.9554 21.9377C21.6932 21.9353 21.4424 21.83 21.2571 21.6445C21.0718 21.459 20.9667 21.2082 20.9646 20.946C20.9624 20.6838 21.0633 20.4312 21.2456 20.2427C21.8027 19.6855 22.2447 19.0241 22.5462 18.2961C22.8478 17.5682 23.003 16.788 23.003 16C23.003 15.2121 22.8478 14.4319 22.5462 13.7039C22.2447 12.9759 21.8027 12.3145 21.2456 11.7573C21.0583 11.5698 20.9531 11.3157 20.9531 11.0507C20.9531 10.7857 21.0583 10.5315 21.2456 10.344L21.2442 10.3427Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1749_28086",
    x: 1,
    y: 2.41016,
    width: 30,
    height: 27.1799,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1749_28086"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1749_28086",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1749_28086",
    x: 19.9531,
    y: 9.04956,
    width: 6.05078,
    height: 13.8882,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1749_28086"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1749_28086",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundOnIcon);
export default __webpack_public_path__ + "static/media/SoundOnIcon.95d6e7b2d25b9223d4928b0f02638dca.svg";
export { ForwardRef as ReactComponent };